import { render, staticRenderFns } from "./deletedata.vue?vue&type=template&id=099271b0"
import script from "./deletedata.vue?vue&type=script&lang=js"
export * from "./deletedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports